import type { WorkflowFieldValue, WorkflowRecord } from '../../types'

export type FieldValue = {
  name: string
  value: WorkflowFieldValue
}

/**
 * Finds a configured field by its generated ID.
 *
 * `WorkflowRecord.values` is keyed by the field's display name, while the
 * server configuration identifies fields by ID. Each transformed value carries
 * its own `fieldId`, so lookup must inspect the entries instead of indexing the
 * object with the configured ID.
 */
export function findFieldValue(
  record: WorkflowRecord,
  fieldId: string
): FieldValue | undefined {
  for (const [name, value] of Object.entries(record.values)) {
    if (value.fieldId === fieldId) return { name, value }
  }
  return
}

/**
 * Resolves the status shown to users.
 *
 * Open records have a status relation. Draft and Closed are system states with
 * no status record, so `closed` distinguishes those two cases.
 */
export function statusText(record: WorkflowRecord) {
  if (record.status) return record.status.name
  if (record.closed) return 'Closed'
  return 'Draft'
}
